import * as LabelPrimitive from "@radix-ui/react-label";
import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "@gettactic/helpers";

const labelVariants = cva("");

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {
  /** Shows the label in the error colour, for a field that failed validation. */
  isInvalid?: boolean;
}

/**
 * The label of a form field (Radix Label): 12px semibold. Point `htmlFor` at the field's `id`
 * so clicking the label focuses the field and screen readers announce it.
 */
const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, isInvalid, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      labelVariants(),
      "flex w-full items-center justify-between space-x-2 text-secondary-foreground",
      "form-field-label font-semibold text-[12px] text-neutral-900",
      isInvalid && "text-destructive",
      className
    )}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
